import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {addUpcomingMovies} from '../utils/MovieSlice'
import {API_OPTIONS} from '../utils/Constants'

const useUpcoming = () =>{
   
  const dispatch = useDispatch();
 
  const  getUpcomingMovies = async () =>{
  const data = await fetch('https://api.themoviedb.org/3/movie/upcoming?&page=1', API_OPTIONS)
  const json = await data.json();
  dispatch(addUpcomingMovies(json.results)); 

}

useEffect(()=>{
  getUpcomingMovies();
},[])}

export default useUpcoming;